

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DrG4wAJ6.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/4vq2VORQ.js","_app/immutable/chunks/CtZl-tYg.js","_app/immutable/chunks/DDTo001e.js","_app/immutable/chunks/DwDOsa2J.js","_app/immutable/chunks/DXK7xvw7.js"];
export const stylesheets = [];
export const fonts = [];
